/**
 * AI SDR チャットAPI クライアント
 *
 * 接続先は第2世代の `aisdr` 関数。既存のメール/カレンダーAPI（第1世代
 * `functions`）とは別関数なので、ベースURLも別に持つ。
 * ローカル検証時のみ .env.development.local の REACT_APP_AISDR_API で
 * エミュレータに向ける。
 */
export const aisdrApiBase =
  process.env.REACT_APP_AISDR_API ||
  "https://asia-northeast1-non-apo.cloudfunctions.net/aisdr";

/**
 * 訪問者の登録と会話の開始/再開。
 * 挨拶文・履歴・クイック返信をまとめて受け取る。
 *
 * @returns {Promise<object|null>}
 */
export const startVisit = async (params) => {
  try {
    const response = await fetch(`${aisdrApiBase}/visitor`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(params),
    });
    if (!response.ok) {
      console.log("aisdr /visitor が失敗しました:", response.status);
      return null;
    }
    return await response.json();
  } catch (error) {
    console.log("aisdr /visitor に接続できませんでした", error);
    return null;
  }
};

/**
 * AI SDR のチャット応答をSSEで受け取る。
 * lead-dynamics の widget.js streamSSE と同じフレーム形式
 * （event: <name> / data: <json> の空行区切り）を前提にする。
 *
 * @param {object}   params
 * @param {function} onEvent (eventName, data) => void
 * @returns {Promise<void>}
 */
export const streamChat = async (params, onEvent) => {
  const response = await fetch(`${aisdrApiBase}/chat`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(params),
  });

  if (!response.ok) {
    throw new Error(`chat failed: ${response.status}`);
  }
  if (!response.body) {
    // ストリーム非対応の環境向けフォールバック
    const data = await response.json();
    onEvent("done", data);
    return;
  }

  const reader = response.body.getReader();
  const decoder = new TextDecoder();
  let buffer = "";

  // eslint-disable-next-line no-constant-condition
  while (true) {
    const { done, value } = await reader.read();
    if (done) break;
    buffer += decoder.decode(value, { stream: true });

    let index;
    while ((index = buffer.indexOf("\n\n")) >= 0) {
      const frame = buffer.slice(0, index);
      buffer = buffer.slice(index + 2);

      let eventName = null;
      let dataStr = null;
      frame.split("\n").forEach((line) => {
        if (line.startsWith(":")) return; // パディング/コメント
        if (line.startsWith("event:")) eventName = line.slice(6).trim();
        else if (line.startsWith("data:")) dataStr = line.slice(5).trim();
      });

      if (dataStr) {
        try {
          onEvent(eventName, JSON.parse(dataStr));
        } catch (error) {
          console.log("SSEフレームの解析に失敗", error);
        }
      }
    }
  }
};

export default streamChat;
